/**
 * 헤더 파트너 메뉴 — 로그아웃.
 *
 * 파트너 메뉴는 Shop_Setup 세션 쿠키가 있을 때만 서버에서 렌더되므로,
 * 여기서는 로그아웃 요청 후 새로고침만 처리한다. 버튼([data-partner-logout])은 햄버거 밖에도 있을 수 있다.
 */

import { busy } from './busyButton';

const InitPartnerNav = () => {
  const root = document.querySelector('[data-partner-nav]');

  if (!root) {
    return;
  }

  // 로그아웃 버튼은 햄버거 안에도, 데모 세션 안내 화면(template-parts/demo-gate.php)에도 있다 — 문서에서 위임으로 받는다.
  // data-logout-to 가 있으면 새로고침 대신 그 주소(홈)로 간다 — 안내 화면에 그대로 남아 있으면 안 되므로
  document.addEventListener('click', async (event) => {
    const logoutButton = event.target.closest?.('[data-partner-logout]');

    if (!(logoutButton instanceof HTMLButtonElement) || logoutButton.disabled) {
      return;
    }

    // 성공 · 실패 모두 finally 에서 페이지를 옮기므로 되돌릴 필요가 없다
    busy(logoutButton, '로그아웃 중…');

    const body = new URLSearchParams({ action: 'qrshop_setup_logout', nonce: root.dataset.nonce });

    try {
      await fetch(root.dataset.ajaxUrl, { method: 'POST', body, credentials: 'same-origin' });
    } finally {
      const target = logoutButton.dataset.logoutTo || '';

      if ('' !== target) {
        window.location.href = target;
      } else {
        window.location.reload();
      }
    }
  });
};

export default InitPartnerNav;
